module.exports = __webpack_public_path__ + "img/colazione_2.8af968c3.jpeg";